(ns practitest.frontend.forms3.entity-form.collab-ws
  (:require [clojure.string :as str]
            [practitest.frontend.common-old-fe.logging :as log]
            [practitest.frontend.common-entities.metadata :as metadata :refer [entities-metadata]]
            [practitest.frontend.forms3.entity-form.collab-events :as collab-events]
            [practitest.frontend.routing.backend-routes :as broutes]
            [re-frame.core :as re-frame]))

(re-frame/reg-event-fx
  ::subscribe-to-form-ws
  [[re-frame/trim-v]]
  (fn [{:keys [db]} [scopes]]
    (if (= (get-in db [:collab :state]) :connected)
      (do
        (log/info ::subscribe-to-form-ws "Initialize collab in forms")
        (let [collab-custom-events {"field-focus" [[::handle-field-focus]]
                                    "field-blur" [[::handle-field-blur]]
                                    "online" [[::handle-online]]
                                    "update" [[::handle-update]]
                                    "presence" [[::handle-presence]]}]
          {:db (assoc-in db [:options :collab-custom-events] collab-custom-events)
           :fx [[:dispatch [:practitest.frontend.events/collab-subscribe-scopes scopes]]
                [:dispatch [:practitest.frontend.events/request-presence [(get-in db [:current-project :id])]]]]}))
      (do
        (log/info ::subscribe-to-form-ws "Websocket not connected yet, will retry in 1 second")
        {:fx [[:dispatch-later {:ms 1000 :dispatch [::subscribe-to-form-ws scopes]}]]}))))

;; Add cleanup event to unsubscribe from forms3 scopes when leaving page
(re-frame/reg-event-fx
  ::unsubscribe-form-ws
  [[re-frame/trim-v]]
  (fn [{:keys [db]} [scopes]]
    (log/info ::unsubscribe-form-ws "Forms3 unsubscribing from collaboration scopes")
    (when (= (get-in db [:collab :state]) :connected)
      {:fx [[:dispatch [:practitest.frontend.events/collab-unsubscribe-scopes scopes]]]})))

;; Collaboration message handlers for centralized websocket
(re-frame/reg-event-fx
  ::handle-field-focus
  [[re-frame/trim-v]]
  (fn [{:keys [db]} [message]]
    (let [current-user-id (get-in db [:current-user :id])
          msg-user-id (get-in message [:user :id])
          base-form-id (get-in metadata/entities-metadata
                               [(keyword (str/lower-case (:entity-type message))) :form-id])
          form-id (str (name base-form-id) "-" (:entity-id message))]
      (when (and (not= msg-user-id current-user-id) form-id)
        {:dispatch [::collab-events/set-field-editing-user 
                    form-id
                    (:field-id message)
                    (:user message)]}))))

(re-frame/reg-event-fx
  ::handle-field-blur
  [[re-frame/trim-v]]
  (fn [{:keys [db]} [message]]
    (let [current-user-id (get-in db [:current-user :id])
          msg-user-id (get-in message [:user :id])
          base-form-id (get-in metadata/entities-metadata
                               [(keyword (str/lower-case (:entity-type message))) :form-id])
          form-id (str (name base-form-id) "-" (:entity-id message))]
      (when (and (not= msg-user-id current-user-id) form-id)
        {:dispatch [::collab-events/clear-field-editing-user 
                    form-id
                    (:field-id message)
                    msg-user-id]}))))

(re-frame/reg-event-fx
  ::handle-online
  [[re-frame/trim-v]]
  (fn [_ [message]]
    (let [user (merge (:user message) (:args message))]
      {:dispatch [::collab-events/update-online-user user]})))

(re-frame/reg-event-fx
  ::handle-update
  [[re-frame/trim-v]]
  (fn [{:keys [db]} [message]]
    (let [current-user-id (get-in db [:current-user :id])
          msg-user-id (get-in message [:user :id])
          current-entity (keyword (str/lower-case (:entity message)))
          updated-entity (broutes/get-url-view
                          (get-in entities-metadata [current-entity :urls :edit])
                          {:id (:id message) :p_id (:project_id message)})
          is-same-entity-updated (str/includes? updated-entity (.-pathname js/window.location))
          need-to-update? (and is-same-entity-updated
                               (not= msg-user-id current-user-id))
          form-id (get-in metadata/entities-metadata
                          [(keyword (str/lower-case (:entity message))) :form-id])]
      (cond-> {}
        need-to-update? (assoc :dispatch [::collab-events/set-form-touched form-id true])))))

(re-frame/reg-event-fx
  ::handle-presence
  [[re-frame/trim-v]]
  (fn [_ [message]]
    {:dispatch [::collab-events/set-presence-users (:projects message)]}))
